// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gdpr_container .gdpr__checkbox[data-v-0a0bb7ea]{width:100%;max-height:inherit;color:inherit}.gdpr_container .gdpr__text[data-v-0a0bb7ea]{font-size:14px;line-height:1.4}.gdpr_container .gdpr__text[data-v-0a0bb7ea] a{text-decoration:underline}@media (max-width:767px){.gdpr_container .gdpr__text[data-v-0a0bb7ea]{font-size:12px}}", ""]);
// Exports
module.exports = exports;
